var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRender)?_c(`channel-${_vm.channelId}-fieldType-${_vm.fieldType}`,{tag:"component",attrs:{"fieldTypeInfo":_vm.fieldTypeInfo,"fieldInfo":_vm.fieldInfo},on:{"save":_vm.handleSave}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }